import { connect } from 'react-redux';
import Viewer from '../components/Viewer/Viewer';

const mapStateToProps = (state) => {
  return {
    baseUrl: '',
    url: state.outputs.selectedUrl.includes("design-specifications")
      ? state.outputs.selectedUrl + "?x=" + Date.now()
      : state.outputs.selectedUrl,
    id: 'outputs',
  };
};

const OutputsViewer = connect(mapStateToProps, null)(Viewer);

export default OutputsViewer;
